import React from "react";
import {
    Input
} from "reactstrap";

const UpwardReduxInput = ({ input, controlledValue, meta:{ touched, error, warning }, ...custom })=> {
    return (
        <Input {...(touched ? { valid: !error } : {})} {...input} {...custom} className={ touched && error ? " is-invalid " : "" } value={controlledValue} />
    )
};

export default UpwardReduxInput;